import { gql } from "@apollo/client";


export const CREATE_USER_IN_COMPANY = gql`
    mutation CreateUserInCompany($email: String!, $password: String!, $name: String, $role: String) {
        createUserInCompany(email: $email, password: $password, name: $name, role: $role) {
            id
            email
            name
            role
        }
    }
`;